import React, { Component } from 'react';
import {
    CustomInput,
    CustomForm,
    CustomSelect,
    CustomButton,
    CustomFormLayout,
    CustomFormFooter
} from 'modules/form';
import { localizer } from 'utils/localizer';
import { createQuote } from '../../QuoteActions';
import AppStore from 'AppStore';

class CreateQuoteForm extends CustomForm {
    constructor(props) {
        super(props);
    }
    onSubmitHandler = () => {
        if (this.isFormValid()) {
            const form = this.serializeForm();
            createQuote(form);
        }
    };
    componentWillMount() {
        const profile = AppStore.getProfile();
        this.options = localizer.LEASE_TYPES;
        if (!profile) {
            this.options = [{ Stretch: 'Stretch' }];
        }
    }

    render() {
        return (
            <div className="create-quote-form ">
                <CustomFormLayout>
                    <CustomSelect
                        name="leaseType"
                        type="text"
                        label={localizer.QUOTES_LBL_LEASE_TYPE}
                        placeholder={localizer.COMPANY_NAME_PLACEHOLDER}
                        form={this}
                        options={this.options}
                        defaultValue="Stretch"
                    />
                    <CustomInput
                        name="cost"
                        type="text"
                        label={localizer.QUOTES_LBL_EQUIPMENT_COST}
                        placeholder="$"
                        form={this}
                    />
                    <CustomFormFooter>
                        <CustomButton
                            align="right"
                            type="primary-button"
                            action={this.onSubmitHandler}
                            label={localizer.QUOTES_BTN_CALC_QUOTE}
                            loading={this.props.loadingState}
                        />
                    </CustomFormFooter>
                </CustomFormLayout>
            </div>
        );
    }
}

export default CreateQuoteForm;



// WEBPACK FOOTER //
// ./src/modules/quote/pages/create-quote/CreateQuoteForm.jsx